const name = 'ru';

const localization = {
    today: 'Ma',
    clear: 'Törlés',
    close: 'Bezárás',
    selectMonth: 'Hónap',
    previousMonth: 'Előző hó',
    nextMonth: 'Következő hó',
    selectYear: 'Év',
    previousYear: 'Előző év',
    nextYear: 'Következő év',
    selectDecade: 'Select Decade',
    previousDecade: 'Previous Decade',
    nextDecade: 'Next Decade',
    previousCentury: 'Previous Century',
    nextCentury: 'Next Century',
    pickHour: 'Óra',
    incrementHour: 'Increment Hour',
    decrementHour: 'Decrement Hour',
    pickMinute: 'Perc',
    incrementMinute: 'Increment Minute',
    decrementMinute: 'Decrement Minute',
    pickSecond: 'Másodperc',
    incrementSecond: 'Increment Second',
    decrementSecond: 'Decrement Second',
    toggleMeridiem: 'Toggle Meridiem',
    selectTime: 'Idő kiválasztás',
    selectDate: 'Dátum kiválasztás',
    dayViewHeaderFormat: {
        month: 'long',
        year: '2-digit'
    },
    locale: 'hu',
    startOfTheWeek: 1,
    dateFormats: {
        LTS: 'h:mm:ss T',
        LT: 'h:mm T',
        L: 'yyyy.MM.dd',
        LL: 'MMMM d, yyyy',
        LLL: 'MMMM d, yyyy h:mm T',
        LLLL: 'dddd, MMMM d, yyyy h:mm T'
    },
    ordinal: (n) => n,
    format: 'L'
};

export {
    localization,
    name
};

/*
(function (g, f) {
    typeof exports === 'object' && typeof module !== 'undefined' ? f(exports) : typeof define === 'function' && define.amd ? define(['exports'], f) : (g = typeof globalThis !== 'undefined' ? globalThis : g || self, f((g.tempusDominus = g.tempusDominus || {}, g.tempusDominus.locales = g.tempusDominus.locales || {}, g.tempusDominus.locales.de = {})));
})(this, (function (exports) {
    'use strict';
    const name = 'hu';
    const localization = {
        today: 'Ma',
        clear: 'Törlés',
        close: 'Bezárás',
        selectMonth: 'Hónap',
        previousMonth: 'Előző hó',
        nextMonth: 'Következő hó',
        selectYear: 'Év',
        previousYear: 'Előző év',
        nextYear: 'Következő év',
        selectDecade: 'Select Decade',
        previousDecade: 'Previous Decade',
        nextDecade: 'Next Decade',
        previousCentury: 'Previous Century',
        nextCentury: 'Next Century',
        pickHour: 'Óra',
        incrementHour: 'Increment Hour',
        decrementHour: 'Decrement Hour',
        pickMinute: 'Perc',
        incrementMinute: 'Increment Minute',
        decrementMinute: 'Decrement Minute',
        pickSecond: 'Másodperc',
        incrementSecond: 'Increment Second',
        decrementSecond: 'Decrement Second',
        toggleMeridiem: 'Toggle Meridiem',
        selectTime: 'Idő kiválasztás',
        selectDate: 'Dátum kiválasztás',
        dayViewHeaderFormat: {
            month: 'long',
            year: '4-digit'
        },
        locale: 'hu',
        startOfTheWeek: 1,
        dateFormats: {
            LTS: 'h:mm:ss T',
            LT: 'h:mm T',
            L: 'yyyy.MM.dd',
            LL: 'MMMM d, yyyy',
            LLL: 'MMMM d, yyyy h:mm T',
            LLLL: 'dddd, MMMM d, yyyy h:mm T'
        },
        ordinal: (n) => n,
        format: 'L'
    };
    exports.localization = localization;
    exports.name = name;
    Object.defineProperty(exports, '__esModule', {
        value: true
    });
}));
*/
